<template>
  <div class="settings-wrapper">
    <!-- ================= HEADER ================= -->
    <div class="settings-header">
      <div>
        <h2>Dialysis Settings</h2>
        <p>Configure billing and consumables for dialysis procedures</p>
      </div>
    </div>

    <!-- ================= SERVICE CHARGE ================= -->
    <div class="card">
      <h3>Dialysis Procedure Charges</h3>

      <div class="form-grid">
        <div>
          <label>Service Name</label>
          <input type="text" value="Dialysis Procedure" disabled />
        </div>

        <div>
          <label>Cash Charge (KES)</label>
          <input
            type="number"
            v-model.number="service.cash_charge"
            placeholder="Cash amount"
          />
        </div>

        <div>
          <label>Insurance Charge (KES)</label>
          <input
            type="number"
            v-model.number="service.insurance_charge"
            placeholder="Insurance amount"
          />
        </div>

        <div>
          <label>Invoice / Corporate Charge (KES)</label>
          <input
            type="number"
            v-model.number="service.corporate_charge"
            placeholder="Corporate amount"
          />
        </div>
      </div>

      <div class="actions">
        <button v-if="!service.exists" class="btn primary" @click="addService">
          Add Procedure Charges
        </button>

        <button v-else class="btn warning" @click="updateService">
          Update Procedure Charges
        </button>
      </div>
    </div>

    <!-- ================= CONSUMABLE BILLING ================= -->
    <!-- <div class="card">
      <h3>Consumables Billing</h3>

      <div class="toggle-row">
        <input
          type="checkbox"
          id="billSeparately"
          v-model="billConsumablesSeparately"
          style="transform: scale(1.9); cursor: pointer"
        />
        <label for="billSeparately">
          Bill consumables separately from dialysis procedure
        </label>
      </div>
    </div> -->

    <!-- ================= PRESET CONSUMABLES ================= -->
    <!-- <div class="card">
      <div class="card-header">
        <h3>Preset Consumables for Dialysis</h3>

        <button class="btn outline" @click="openConsumablesPage">
          Edit / Add Consumables
        </button>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Consumable</th>
            <th>Quantity</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in consumables" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.quantity }}</td>
          </tr>

          <tr v-if="consumables.length === 0">
            <td colspan="3" class="empty">No consumables preset</td>
          </tr>
        </tbody>
      </table>
    </div> -->

   
  </div>
</template>

<script>
import showNotification from "../../../notification/notify";
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "DialysisSettings",

  data() {
    return {
      loading: false,
      service: {
        charge_name: "Dialysis Procedure",
        cash_charge: "",
        insurance_charge: "",
        corporate_charge: "",
        exists: true,
        department_id: 7,
        billing_area: 7,
        charge_id: "",
      },

      billConsumablesSeparately: true,

      consumables: [],

      showConsumablesModal: false,
      editableConsumables: [],
      newConsumable: { name: "", quantity: 1 },
    };
  },

  methods: {
    async updateService() {
      const url = "add_sialysis_charge_setting";
      const resp = await generalApiRequest(url, "POST", this.service, 1);
      showNotification(resp.message);
    },

    async getService() {
      this.loading = true;
      try {
        const url = "get_dialysis_charge_setting";
        const resp = await generalApiRequest(url, "GET", {}, 1);
        this.consumables = resp.consumables;
        //   this.service = [...this.service, ]

        const item = {
          charge_name: "Dialysis Procedure",
          cash_charge: resp.charges.cash_charge,
          insurance_charge: resp.charges.insurance_charge,
          corporate_charge: resp.charges.invoice_charge,
          exists: true,
          department_id: 7,
          billing_area: 7,
          charge_id: resp.charges.charge_id,
        };
        this.service = item;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    openConsumablesPage() {
      this.$router.push(
        "/charge_consumable_specific/" + this.service.charge_id
      );
    },
  },
  mounted() {
    this.getService();
  },
};
</script>

<style scoped>
.settings-wrapper {
  max-width: 1000px;
  margin: auto;
  padding: 24px;
  background: #f9fafb;
}

.settings-header h2 {
  margin: 0;
}

.settings-header p {
  color: #6b7280;
}

.card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

label {
  font-weight: 600;
  font-size: 14px;
}

input {
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
}

.actions {
  margin-top: 15px;
}

.toggle-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.table th,
.table td {
  padding: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.empty {
  text-align: center;
  color: #9ca3af;
}

.btn {
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
}

.btn.primary {
  background: #2563eb;
  color: white;
}

.btn.warning {
  background: #f59e0b;
  color: white;
}

.btn.outline {
  border: 1px solid #2563eb;
  background: transparent;
  color: #2563eb;
}

.btn.danger {
  background: #dc2626;
  color: white;
}

.btn.sm {
  padding: 4px 8px;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: white;
  border-radius: 12px;
  padding: 20px;
  width: 600px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.add-row {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
</style>
